/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
    title: metadata.title,
    /**
     * @see ./edit.js
     */
    icon: {
        src: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_34_2)">
                <rect width="24" height="24" fill="#D9D9D9"/>
                <rect width="24" height="24" fill="url(#paint0_linear_34_2)"/>
                <g filter="url(#filter0_d_34_2)">
                    <g filter="url(#filter1_d_34_2)">
                        <rect x="2" y="2" width="20" height="20" rx="2" fill="white"/>
                    </g>
                    <rect x="2.95239" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="5.61902" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="8.28564" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="10.9048" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="13.619" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="16.2856" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="18.9524" y="8.28589" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="2.95239" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="5.61902" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="8.28564" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="10.9048" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="13.619" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#3A12D9"/>
                    <rect x="16.2856" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="18.9524" y="10.9524" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="2.95239" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="5.61902" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="8.28564" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="10.9048" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="13.619" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="16.2856" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="18.9524" y="13.6191" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="2.95239" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="5.61902" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="8.28564" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="10.9048" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="13.619" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="16.2856" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="18.9524" y="16.2859" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="2.95239" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="5.61902" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="8.28564" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="10.9048" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="13.619" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="16.2856" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="18.9524" y="18.9526" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="2.95239" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="5.61902" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="8.28564" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="10.9048" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="13.619" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="16.2856" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"
                          fill-opacity="0.4"/>
                    <rect x="18.9524" y="5.6189" width="2.19048" height="2.19048" rx="1" fill="#D9D9D9"/>
                    <rect x="2.95239" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                    <rect x="5.61902" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                    <rect x="8.28564" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                    <rect x="10.9048" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                    <rect x="13.619" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                    <rect x="16.2856" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                    <rect x="18.9524" y="2.95239" width="2.19048" height="2.19048" rx="1" fill="#8A8A8A"/>
                </g>
            </g>
            <defs>
                <filter id="filter0_d_34_2" x="-18" y="2" width="60" height="60" filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="20"/>
                    <feGaussianBlur stdDeviation="10"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34_2"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34_2" result="shape"/>
                </filter>
                <filter id="filter1_d_34_2" x="-2" y="2" width="28" height="28" filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34_2"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34_2" result="shape"/>
                </filter>
                <linearGradient id="paint0_linear_34_2" x1="1.752" y1="24.168" x2="19.368" y2="-4.8"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#3D12F9"/>
                    <stop offset="1" stop-color="#FD2B4C"/>
                </linearGradient>
                <clipPath id="clip0_34_2">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    },
    attributes: {

    },
    edit: Edit,
    save: Save
});
